<template>
    <div class="agentWhiteListHolder">
        <div class="errorHolder">
            <div v-if="selectedAgents.length == 0" class="color-6">Select at least one agent</div>
        </div>

        <div class="d-flex mb-1 w-100">
            <input type="text" class="glued-right w-100" :disabled="disabled" v-model="searchString"
                placeholder="Search agent name">
            <div class="glued-left bg-lighter">
                <i class="ico ico-search m-0 fs-normal color-1"></i>
            </div>
        </div>

        <div class="mb-2 w-100 dark fs-small">
            <span></span> <span class="pointer" :class="{ 'notAllowed': disabled }" @click="selectAll(true)">All</span> |
            <span class="pointer" :class="{ 'notAllowed': disabled }" @click="selectAll(false)">None</span>
        </div>

        <ul class="agentList">
            <li v-for="agent in allAgentsQry">
                <checkbox :disabled="disabled" v-model="agent.selected" @input="agentSelectedChanged">
                    <span>
                        {{ agent.brandName }}
                    </span>
                </checkbox>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Loader from '@/tools/loaders/loader1'

export default {
    data() {
        return {
            allAgents: [],
            searchString: null,
            originalAgentArr: null,
        }
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        allowedList: {
            type: Array
        },
        allowedIdArray: {
            type: Array,
            default: function () {
                return []
            }
        },
        startAllSelected: {
            type: Boolean
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getAgents',
        ]),
        allowedIdArrayMixed() {
            // This computed property works as a layer to convert "allowedList" into "allowedIdArray"
            // this allowes us to receive a list of agents (allowedList) or a list of id's (allowedIdArray)
            if (this.allowedList != undefined) {
                return this.allowedList.map(agent => {
                    return agent.id;
                })
            } else {
                return this.allowedIdArray;
            }
        },
        selectedAgents() {
            return this.allAgents.filter(agent => {
                return agent.selected == true;
            })
        },
        allAgentsQry() {
            if (this.searchString) {
                return this.allAgents.filter(
                    (item) => {
                        return this.searchString.toLowerCase().split(' ').every(val => item.brandName.toLowerCase().includes(val))
                    }
                )
            }

            return this.allAgents;
        }
    },
    created() {
        this.setLocalAgents();
    },
    methods: {
        setLocalAgents() {

            this.$set(this, 'allAgents', JSON.parse(JSON.stringify(this.getAgents.filter(channel => channel.salesChannel.channelType === 50))));

            this.allAgents.map(agent => {
                this.$set(agent, 'agentId', agent.id);

                if (this.startAllSelected == true) {
                    this.$set(agent, 'selected', true);
                } else {
                    this.$set(agent, 'selected', this.allowedIdArrayMixed.includes(agent.id));
                }

                return agent;
            })
        },
        outputUpdated(overrideAgenList) {
            this.$emit('input', this.allAgents);
        },
        agentSelectedChanged() {
            this.outputUpdated();
        },
        selectAll(val) {
            if (this.disabled == true) {
                return false;
            }

            this.allAgents.map(agent => {
                agent.selected = val;
            })

            this.outputUpdated();
        },
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss" scoped>
.agentWhiteListHolder {

    .errorHolder {
        height: 1.5rem;
    }

    .agentList {
        max-height: 450px;
        overflow: auto;
    }
}
</style>



// WEBPACK FOOTER //
// AgentWhiteList.vue?9319b628